// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pc-6";
export var imgContainer = "_pc-3";
export var menuIcon = "_pc-5";
export var pillWrapper = "_pc-2";
export var pillsContainer = "_pc-1";
export var subscriptionCard = "_pc-0";
export var subscriptionLogo = "_pc-4";